/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceSchema } from './InstanceSchema';
import {
    InstanceSchemaFromJSON,
    InstanceSchemaFromJSONTyped,
    InstanceSchemaToJSON,
} from './InstanceSchema';
import type { ProcessStateSchema } from './ProcessStateSchema';
import {
    ProcessStateSchemaFromJSON,
    ProcessStateSchemaFromJSONTyped,
    ProcessStateSchemaToJSON,
} from './ProcessStateSchema';

/**
 * 
 * @export
 * @interface WorkerFrontendSchema
 */
export interface WorkerFrontendSchema {
    /**
     * 
     * @type {number}
     * @memberof WorkerFrontendSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof WorkerFrontendSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkerFrontendSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkerFrontendSchema
     */
    name: string;
    /**
     * 
     * @type {InstanceSchema}
     * @memberof WorkerFrontendSchema
     */
    instance?: InstanceSchema;
    /**
     * 
     * @type {ProcessStateSchema}
     * @memberof WorkerFrontendSchema
     */
    currentState: ProcessStateSchema;
}

/**
 * Check if a given object implements the WorkerFrontendSchema interface.
 */
export function instanceOfWorkerFrontendSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "currentState" in value;

    return isInstance;
}

export function WorkerFrontendSchemaFromJSON(json: any): WorkerFrontendSchema {
    return WorkerFrontendSchemaFromJSONTyped(json, false);
}

export function WorkerFrontendSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkerFrontendSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
        'instance': !exists(json, 'instance') ? undefined : InstanceSchemaFromJSON(json['instance']),
        'currentState': ProcessStateSchemaFromJSON(json['current_state']),
    };
}

export function WorkerFrontendSchemaToJSON(value?: WorkerFrontendSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
        'instance': InstanceSchemaToJSON(value.instance),
        'current_state': ProcessStateSchemaToJSON(value.currentState),
    };
}

